import { jsx } from "panel";
import { MarkdownEl } from "common/components/markdown";
import { ArrowType, DisplaySize } from "./types";
export function template() {
  var _a;
  const {
    visibility
  } = this.state;
  const imageUrl = this.attr(`image-src`);
  const {
    print
  } = this.getContext(`i18n`);
  const text = this.params.text ? print(this.params.text) : this.attr(`text`);
  return /* @__PURE__ */ jsx("div", { sel: ".mp-tooltip", attrs: {
    role: `tooltip`
  }, class: {
    "is-tooltip-tour": this.attr(`is-tooltip-tour`),
    "is-dot-line-arrow": this.attr(`arrow-type`) === ArrowType.LineDot,
    "has-max-width": this.attr(`max-width`) !== null || this.attr(`size`) !== DisplaySize.Fit,
    "is-animated": this.helpers.shouldAnimateTooltip(),
    "has-image": !!imageUrl,
    [`is-${visibility}`]: true,
    [`size-${this.attr(`size`)}`]: true,
    "break-word": this.attr(`break-word`),
    "non-blocking": this.attr(`non-blocking`)
  }, style: {
    ...this.attr(`max-width`) && {
      "max-width": this.attr(`max-width`),
      hyphens: `auto`
    },
    ...this.attr(`text-align`) && {
      "text-align": this.attr(`text-align`)
    },
    "--tooltip-offset": `${this.helpers.getOffset()}px`
  }, on: {
    click: this.helpers.stopPropagation,
    mousedown: this.helpers.stopPropagation,
    mouseleave: (ev) => this.hide(ev)
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, imageUrl && /* @__PURE__ */ jsx("img", { sel: ".mp-tooltip-image", attrs: {
    src: imageUrl
  } }), /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }), text && visibility !== this.helpers.VISIBILITY_HIDDEN && /* @__PURE__ */ jsx(MarkdownEl, { sel: ".mp-tooltip-text", attrs: {
    text: text.toString()
  } }), visibility !== this.helpers.VISIBILITY_HIDDEN && ((_a = this.lazyContentRenderer) == null ? void 0 : _a.call(this, this.getContext(`i18n`))), this.attr(`arrow-type`) === ArrowType.Default && !this.attr(`is-tooltip-tour`) ? /* @__PURE__ */ jsx("div", { sel: ".mp-tooltip-arrow" }) : null);
}
